import { QueryClient } from '@tanstack/react-query';

import { GetTotalReviewCountWithAverageRatingByPublicIdQuery } from '@/types/bff/gql-schema';
import { HospitalReviewMetricResponse } from '@/types/hospital';

import { useGetTotalReviewCountWithAverageRatingByPublicIdQuery } from './faceToFace.gql.impl';

interface GetHospitalReviewCountWithAverageRating {
  data?: HospitalReviewMetricResponse;
}
const useGetTotalReviewCountWithAverageRatingByPublicId = (
  hospitalPid: string,
): GetHospitalReviewCountWithAverageRating => {
  const { data } = useGetTotalReviewCountWithAverageRatingByPublicIdQuery(
    {
      publicId: hospitalPid,
    },
    {
      select: convertToHospitalReviewMetricResponse,
      staleTime: 1000 * 60 * 5,
    },
  );
  return { data };
};

export default useGetTotalReviewCountWithAverageRatingByPublicId;

const prefetchQuery = async (queryClient: QueryClient, hospitalPid: string) => {
  const params = { publicId: hospitalPid };

  await queryClient.prefetchQuery(
    useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey(params),
    useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher(params),
  );
};

useGetTotalReviewCountWithAverageRatingByPublicId.prefetchQuery = prefetchQuery;

const convertToHospitalReviewMetricResponse = (
  data: GetTotalReviewCountWithAverageRatingByPublicIdQuery,
): HospitalReviewMetricResponse => {
  const { averageRating, totalCount } = data.getTotalReviewCountWithAverageRatingByPublicId;
  return { averageRating, totalCount };
};
